import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {UserAppletContainerModel} from "../../../../../models/aggregates/applet-store/user-applet-container.model";
import { Observable } from 'rxjs';
import {ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel} from '../shared';

@Injectable({
  providedIn: 'root'
})
export class UserAppletTenantBackOfficeEpService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link/backoffice-ep';
    this.httpClient = http;
  }

  getAppletLoginSubjectLinksByApplet(appletGuid: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<UserAppletContainerModel>> {
    let url = this.apiUrl + '/query/' + appletGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/query/' + appletGuid + '?' + pagination.getQueryKeyValues();;
    }
    return this.httpClient.get<PagingResponseModel<UserAppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  searchAppletLoginSubjectLinksByApplet(appletGuid: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<UserAppletContainerModel>> {
    let url = this.apiUrl + '/search/' + appletGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/search/' + appletGuid + '?' + pagination.getQueryKeyValues();;
    }
    return this.httpClient.get<PagingResponseModel<UserAppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  async exportAgentCsvAsBlob(appletGuid: string, authorization: string, apiVisa: ApiVisa){
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/' + appletGuid + '/export-csv';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

  public put(dtoObject: UserAppletContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<UserAppletContainerModel>> {
    let url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link';
    return this.httpClient.put<BasicApiResponseModel<UserAppletContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public deleteLink(guid: string, visa: ApiVisa): Observable<ApiResponseModel<UserAppletContainerModel>> {
    const url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'applet-login-subject-link';
    return this.httpClient.delete<ApiResponseModel<UserAppletContainerModel>>(
      url + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

}
